import { Slider, InputNumber, Space } from 'antd';

import styles from './index.module.scss';

interface SliderWithInputNumberProps {
  value?: number;
  min: number;
  max: number;
  step?: number;
  onChange?: (value: number | null) => void;
}

export const SliderWithInputNumber = ({
  value,
  min,
  max,
  step,
  onChange,
}: SliderWithInputNumberProps) => {
  return (
    <Space direction={'horizontal'}>
      <Slider
        min={min}
        max={max}
        step={step}
        onChange={onChange}
        defaultValue={50}
        value={value}
        className={styles.slider}
      />

      <InputNumber
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={onChange}
      />
    </Space>
  );
};
